module.exports = __webpack_public_path__ + "static/media/Alan.80cd5f06.jpg";